import { render } from "./maxFoodDisplay.vue?vue&type=template&id=c7bf321a"
import script from "./maxFoodDisplay.vue?vue&type=script&lang=js"
export * from "./maxFoodDisplay.vue?vue&type=script&lang=js"

import "./maxFoodDisplay.vue?vue&type=style&index=0&id=c7bf321a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__